import React from "react";
import { Link } from "react-router-dom";
import { Download, Send, ChevronRight, Star, Smartphone, IndianRupee, Wallet, Headphones } from "lucide-react";
import { useData } from "../data/DataContext";
import { GoldButton, GhostButton, Corners } from "./Hero";

export const AppHero = ({ name, logo, rating, size, downloads, bonus, minWithdraw = 100, onDownload, testPrefix, tagline }) => {
  const { telegramLink: TELEGRAM_LINK } = useData();
  return (
  <div data-testid={`${testPrefix}-hero`} className="pt-1">
    <nav data-testid={`${testPrefix}-breadcrumb`} className="flex items-center gap-1.5 text-[13px] sm:text-sm font-semibold text-emerald-50/70 flex-wrap">
      <Link to="/" className="hover:text-[#ffb224] transition-colors">Home</Link>
      <ChevronRight size={14} className="text-emerald-50/40" />
      <Link to="/yono-all-games" className="hover:text-[#ffb224] transition-colors">All games</Link>
      <ChevronRight size={14} className="text-emerald-50/40" />
      <span className="text-[#ffb224]">{name}</span>
    </nav>

    <div className="mt-6"><div className="group relative inline-block">
      <Corners color="border-[#ffb224]" size="w-7 h-7" />
      <img src={logo} alt={`${name} APK`} className="w-[150px] h-[150px] sm:w-[180px] sm:h-[180px] rounded-[26px] object-cover shadow-[0_24px_50px_-18px_rgba(0,0,0,0.8)] ring-1 ring-[#1c5f35]" />
    </div></div>

    <div className="mt-5">
    <span className="inline-flex items-center gap-2 bg-[#073c1b] border border-[#1c5f35] text-emerald-50/90 text-[13px] font-bold px-3.5 py-1.5 rounded-full">
      <span className="w-2 h-2 rounded-full bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.9)]" /> Android APK
    </span>
    </div>

    <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#ffb224] tracking-tight leading-[1.05]">{name}</h1>

    <div data-testid={`${testPrefix}-stats`} className="mt-5 grid grid-cols-4 gap-2 sm:gap-3 max-w-xl">
      {[
        { icon: Star, value: rating, label: "Rating", filled: true },
        { icon: Smartphone, value: size, label: "MB", filled: true },
        { icon: Download, value: downloads, label: "Download" },
        { icon: IndianRupee, value: bonus, label: "Bonus" },
      ].map(({ icon: Icon, value, label, filled }, i) => (
        <div
          key={label}
          className="group relative overflow-hidden flex flex-col items-center text-center gap-1.5 bg-gradient-to-b from-[#0b4d24] to-[#052b14] border border-[#1c5f35] rounded-2xl px-1.5 py-3 sm:py-3.5 border-b-[4px] border-b-[#0a3a1b] hover:border-[#ffb224]/60 hover:-translate-y-0.5 active:scale-[0.96] transition-all duration-200"
          style={{ animation: "fadeUp 0.5s ease both", animationDelay: `${150 + i * 70}ms` }}
        >
          <Corners inside size="w-3.5 h-3.5" color="border-[#ffb224]/70" />
          <span className="w-9 h-9 sm:w-11 sm:h-11 rounded-xl bg-[#ffb224] text-[#062a13] flex items-center justify-center shadow-[0_6px_14px_-6px_rgba(255,178,36,0.9)] border-b-[3px] border-[#b47400] group-hover:scale-110 transition-transform">
            <Icon size={18} fill={filled ? "currentColor" : "none"} strokeWidth={filled ? 0 : 2.6} />
          </span>
          <p className="font-extrabold text-white text-[13px] sm:text-lg leading-none mt-0.5">{value}</p>
          <p className="text-[10px] sm:text-xs text-emerald-50/60 font-semibold uppercase tracking-wide">{label}</p>
        </div>
      ))}
    </div>

    <div className="mt-6 flex flex-col gap-4 sm:gap-5">
      <GoldButton data-testid={`${testPrefix}-download-btn`} onClick={onDownload} className="w-full text-base sm:text-xl py-3 sm:py-4">
        Download APK <Download size={20} strokeWidth={2.6} />
      </GoldButton>
      <a href={TELEGRAM_LINK} target="_blank" rel="noreferrer" data-testid={`${testPrefix}-telegram-btn`} className="contents">
        <GhostButton className="w-full text-base sm:text-xl py-3 sm:py-4"><Send size={18} /> Join Telegram</GhostButton>
      </a>
    </div>

    <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-emerald-50/70 font-medium">
      <span className="flex items-center gap-1.5"><Wallet size={15} className="text-[#ffb224]" /> ₹{minWithdraw} min. withdrawal</span>
      <span className="flex items-center gap-1.5"><Headphones size={15} className="text-[#ffb224]" /> 24/7 support</span>
      <button data-testid={`${testPrefix}-apk-link`} onClick={onDownload} className="text-[#ffb224] font-bold underline underline-offset-4 hover:text-[#ffc14d]">{name} APK</button>
    </div>

    {tagline && (
      <>
        <hr className="my-7 border-[#1c5f35]" />
        <h2 data-testid={`${testPrefix}-tagline`} className="text-lg sm:text-xl font-bold text-white leading-snug">{tagline}</h2>
      </>
    )}
  </div>
  );
};

export default AppHero;
